export default "__VITE_ASSET__22946d92__"